import { useMemo } from 'react'

import { ReportCategory } from '@tribeplatform/gql-client/types'

import { useI18n } from '../i18n/index.js'

export function useReportCategoryLabels(): Record<ReportCategory, string> {
  const { $t } = useI18n()

  return useMemo(
    () => ({
      [ReportCategory.HARASSMENT]: $t({
        defaultMessage: 'Harassment or hate speech',
        id: 'ReportCategory.Harassment.Title',
      }),
      [ReportCategory.PRIVACY_VIOLATION]: $t({
        defaultMessage: 'Privacy violation',
        id: 'ReportCategory.Privacy.Title',
      }),
      [ReportCategory.SPAM]: $t({
        defaultMessage: 'Spam',
        id: 'ReportCategory.Spam.Title',
      }),
      [ReportCategory.MISINFORMATION]: $t({
        defaultMessage: 'Misinformation',
        id: 'ReportCategory.Misinformation.Title',
      }),
      [ReportCategory.VIOLENCE]: $t({
        defaultMessage: 'Harmful activities',
        id: 'ReportCategory.Harmful.Title',
      }),
      [ReportCategory.NUDITY]: $t({
        defaultMessage: 'Adult content',
        id: 'ReportCategory.Adult.Title',
      }),
      [ReportCategory.COPYRIGHT_INFRINGEMENT]: $t({
        defaultMessage: 'Copyright or trademark infringement',
        id: 'ReportCategory.Copyright.Title',
      }),
      [ReportCategory.ILLEGAL_CONTENT]: $t({
        defaultMessage: 'Illegal content',
        id: 'ReportCategory.IllegalContent.Title',
      }),
      [ReportCategory.SUICIDE]: $t({
        defaultMessage: 'Self-harm',
        id: 'ReportCategory.Suicide.Title',
      }),
      [ReportCategory.TERRORISM]: $t({
        defaultMessage: 'Terrorism',
        id: 'ReportCategory.Terrorism.Title',
      }),
      [ReportCategory.OTHER]: $t({
        defaultMessage: 'Other',
        id: 'ReportCategory.other.Title',
      }),
    }),
    [$t],
  )
}
